import { deleteApiWithData, getApi, postApi } from 'apis';

const deleteCompanyCurrency = async (data: any) => {
	return await deleteApiWithData('/companyCurrency', data);
};

const createCompanyCurrency = async (data: any) => {
	return await postApi('/companyCurrency/', data);
};

const getAllCompanyCurrency = async () => {
	return await getApi('/companyCurrency');
}

export const companyCurrencyApi = {
createCompanyCurrency,
deleteCompanyCurrency,
getAllCompanyCurrency
}